/**
 * The four How it works icons, drawn in Sprout Buddy's style (design idea 2,
 * 8 Oct 2026): the same dark outline and warm colours, so they belong with
 * the mascot. They replaced emoji, which look different on Windows, iPhone
 * and Android and never quite match a drawn character.
 */
const INK = '#2B1D14'
const W = 2.6

export type LandingIcon = 'words' | 'again' | 'grows' | 'report'

export function LandingIconSvg({ name, size = 40 }: { name: LandingIcon; size?: number }) {
  return (
    <svg viewBox="0 0 48 48" width={size} height={size} aria-hidden style={{ display: 'block' }}>
      {name === 'words' ? (
        // An open book with a sprout growing out of it: their own words.
        <g strokeLinejoin="round" strokeLinecap="round">
          <path d="M24 16 C24 10 30 6 36 8 C36 14 30 17 24 16 Z" fill="#9BDB4D" stroke={INK} strokeWidth={W - 0.4} />
          <path d="M24 16 C24 11 19 8 14 10 C15 15 20 17 24 16 Z" fill="#6CB33F" stroke={INK} strokeWidth={W - 0.4} />
          <path d="M24 16 L24 22" stroke={INK} strokeWidth={W} />
          <path d="M6 22 C14 19 20 20 24 23 C28 20 34 19 42 22 L42 40 C34 37 28 38 24 41 C20 38 14 37 6 40 Z"
            fill="#FFF7E6" stroke={INK} strokeWidth={W} />
          <path d="M24 23 L24 41" stroke={INK} strokeWidth={W - 0.6} />
          <path d="M10 27 L19 26 M10 32 L19 31 M29 26 L38 27 M29 31 L38 32" stroke="#E8833A" strokeWidth={2} />
        </g>
      ) : name === 'again' ? (
        // Two arrows going round: a word comes back until it sticks.
        <g strokeLinecap="round" strokeLinejoin="round" fill="none">
          <path d="M37 18 A15 15 0 0 0 10 20" stroke={INK} strokeWidth={6.5} />
          <path d="M37 18 A15 15 0 0 0 10 20" stroke="#4C7BE0" strokeWidth={3.5} />
          <path d="M11 30 A15 15 0 0 0 38 28" stroke={INK} strokeWidth={6.5} />
          <path d="M11 30 A15 15 0 0 0 38 28" stroke="#E8833A" strokeWidth={3.5} />
          <path d="M33 11 L38 18 L30 20 Z" fill="#4C7BE0" stroke={INK} strokeWidth={2.2} />
          <path d="M15 37 L10 30 L18 28 Z" fill="#E8833A" stroke={INK} strokeWidth={2.2} />
          <circle cx={24} cy={24} r={4} fill="#9BDB4D" stroke={INK} strokeWidth={2.2} />
        </g>
      ) : name === 'grows' ? (
        // A pot with a sprout: grows only with real learning.
        <g strokeLinejoin="round" strokeLinecap="round">
          <path d="M24 26 L24 14" stroke={INK} strokeWidth={4.5} />
          <path d="M24 26 L24 14" stroke="#3E8E6A" strokeWidth={2} />
          <path d="M24 16 C22 8 13 6 8 10 C11 17 19 19 24 16 Z" fill="#9BDB4D" stroke={INK} strokeWidth={W - 0.4} />
          <path d="M24 19 C26 11 35 9 40 13 C37 20 29 22 24 19 Z" fill="#6CB33F" stroke={INK} strokeWidth={W - 0.4} />
          <path d="M11 27 L37 27 L34 42 C34 43 33 44 32 44 L16 44 C15 44 14 43 14 42 Z"
            fill="#E8833A" stroke={INK} strokeWidth={W} />
          <path d="M9 25 L39 25 L39 30 L9 30 Z" fill="#D85E10" stroke={INK} strokeWidth={W} />
        </g>
      ) : (
        // A clipboard with ticks and one dot still to do: an honest report.
        <g strokeLinejoin="round" strokeLinecap="round">
          <rect x={10} y={8} width={28} height={36} rx={4} fill="#B07A50" stroke={INK} strokeWidth={W} />
          <rect x={13} y={12} width={22} height={29} rx={2} fill="#FFFFFF" stroke={INK} strokeWidth={W - 0.6} />
          <rect x={18} y={5} width={12} height={7} rx={2} fill="#C9D3DC" stroke={INK} strokeWidth={W - 0.4} />
          <path d="M16 20 L18 22 L21 18" fill="none" stroke="#3E8E6A" strokeWidth={2.4} />
          <path d="M16 28 L18 30 L21 26" fill="none" stroke="#3E8E6A" strokeWidth={2.4} />
          <circle cx={18.5} cy={35} r={2} fill="#F2C230" stroke={INK} strokeWidth={1.4} />
          <path d="M24 20 L32 20 M24 28 L32 28 M24 35 L30 35" stroke="#8A94A0" strokeWidth={2} />
        </g>
      )}
    </svg>
  )
}
